import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonVariant, DsButtonModule } from '@bmw-ds/components';

import { RoleGroup } from '../../../../auth/roles';
import { useAuthorization } from '../../../authorization/authorization.composable';
import { LoadingIndicatorComponent } from '../../../loading/loading-indicator.component';
import { AddedCustomerToVehicleEvent } from '../../../web-component/event.model';
import { WebComponentDirective } from '../../../web-component/web-component.directive';
import { AddCustomerToVehicleContainer } from './add-customer-to-vehicle.container';
import { AddCustomerToVehicleSize } from './add-customer-to-vehicle.model';

@Component({
  selector: 'cdf-add-customer-to-vehicle-web-component',
  imports: [LoadingIndicatorComponent, DsButtonModule, AddCustomerToVehicleContainer],
  host: {
    class: 'd-flex align-items-center justify-content-center',
    '[style.min-height]': 'loadingIndicatorSize()',
    '[style.min-width]': 'loadingIndicatorSize()',
  },
  template: `
    @if (authorization.loading()) {
      <cdf-loading-indicator noSpacing />
    } @else if (authorization.authorized()) {
      <cdf-add-customer-to-vehicle
        [vin]="vin()"
        [size]="size()"
        [variant]="variant()"
        (addedCustomer)="addedCustomerToVehicle.emit({ type: 'ADDED_CUSTOMER_TO_VEHICLE', accountNumber: $event })"
      />
    } @else {
      <!-- Button is not shown, the user is not authorized -->
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCustomerToVehicleWebComponent extends WebComponentDirective {
  protected readonly authorization = useAuthorization({ allowedRoles: RoleGroup.CDF_WRITE });

  readonly vin = input<string>();
  readonly size = input<AddCustomerToVehicleSize>('md');
  readonly variant = input<ButtonVariant>();

  readonly loadingIndicatorSize = computed(() => {
    switch (this.size()) {
      case 'lg':
        return 'var(--ds-shape-size-ymin-button-lg)';
      case 'sm':
        return 'var(--ds-shape-size-ymin-button-sm)';
      default:
        return 'var(--ds-shape-size-ymin-button)';
    }
  });

  readonly addedCustomerToVehicle = output<AddedCustomerToVehicleEvent>();
}
